module.exports = __webpack_public_path__ + "img/fluid-wagon-1.65b34f96.png";